import customAxios from './axios';
import CONFIG from '../../config';

export const getAllAdminDashboardJobs = () => {
    return customAxios.get(CONFIG.apiURL + '/BackOfficeDashboard/Jobs').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllRecentJobs = () => {
    return customAxios.get(CONFIG.apiURL + '/BackOfficeDashboard/RecentJobs').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllSLAForJobs = () => {
    return customAxios.get(CONFIG.apiURL + '/BackOfficeDashboard/SLAForJobs').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllMetrices = () => {
    return customAxios.get(CONFIG.apiURL + '/BackOfficeDashboard/Metrices').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getJobsCount = (countType="overAll") => {
    return customAxios.get(CONFIG.apiURL + '/BackOfficeDashboard/JobCounts?countType='+countType).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getWeeklyJobsCount = () => {
    return customAxios.get(CONFIG.apiURL + '/BackOfficeDashboard/JobCountsInWeek').then(res => {
        let response = res['data'];
        return response;
    });
};

// export const getDailyJobsCount = () => {
//     return customAxios.get(CONFIG.apiURL + '/BackOfficeDashboard/JobCountsInDays').then(res => {
//         let response = res['data'];
//         return response;
//     });
// };

export const getJobCountsForActionRequested = () => {
    return customAxios.get(CONFIG.apiURL + '/BackOfficeDashboard/GetJobCountsForActionRequested').then(res => {
        let response = res['data'];
        return response;
    });
}

export const getAllAdminJobs = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/BackOfficeReport/GetJobs', payload).then(res => {
        let response = res['data'];
        return response;
    });
};